export const GET_ALL_ADS = 'GET_ALL_ADS'
export const UPDATE_AD = 'UPDATE_AD'
export const DELETE_AD = 'DELETE_AD'
export const ADD_AD = 'ADD_AD'
export const GET_AD_BY_CITY = 'GET_AD_BY_CITY'
export const SINGLE_AD='SINGLE_AD'
export const AD_ERROR = 'AD_ERROR'
export const UPLOAD_IMAGE='UPLOAD_IMAGE'
